export const SEARCH_ADS_FORM = 'searchAds';
export const EXTRA_FILTERS_QUERY_KEY = 'extra';
export const EXACT_SEARCH_TYPE = 'exact';
export const SIMILAR_SEARCH_TYPE = 'similar';
export const AD_SEARCH_TRACK_AS = 'adSearch';
export const LAST_SEARCH_LOCATION_KEY = 'lastSearchQuery';
